$(() => {
    initializeButtonsAlt();
});

function initializeButtonsAlt() {
    $(".iata-widget ").each(function () {
        new ButtonsAlt(this);
    });
}

class ButtonsAlt {

    el: JQuery<HTMLElement>;

    constructor(carouselContainerElement: HTMLElement) {
        this.el = $(carouselContainerElement);
        const buttons = this.el.find($( ".p-button" ));
        if (buttons.filter(':not([aria-label])')) {
            buttons.attr("aria-label", "Choice");
        }
    }
}
